module.exports = __webpack_public_path__ + "media/newstyle/images/bottom-background-b53afa4a483ee32bcd766407fa90f079.png";